import { render, staticRenderFns } from "./DocketEntryEditorNotifications.vue?vue&type=template&id=09aaa277&scoped=true&"
import script from "./DocketEntryEditorNotifications.vue?vue&type=script&lang=js&"
export * from "./DocketEntryEditorNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DocketEntryEditorNotifications.vue?vue&type=style&index=0&id=09aaa277&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aaa277",
  null
  
)

export default component.exports